<template>
  <BTable
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="actions"
    v-on="$listeners || {}"
  >
    <!--  -->

    <template #item.username="{ header, item, value: v }">
      <router-link
        :to="header.getRoute(item)"
        v-text="v"
      />
    </template>

    <!--  -->
  </BTable>
</template>

<script>
import {
  TABLE_ACTIONS,
  TABLE_HEADERS,
} from '@/views/Sessions/table-headers'

import BTable from '@/components/common/BTable.vue'


export default {
  name: 'BTableSessions',
  components: {
    BTable,
  },
  inheritAttrs: false,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
}
</script>
